import {getJson} from '@/util/ajaxUtils';

export function ping() {
    return getJson('/toolkits/ping');
}
